module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.4627123.eot";